




























































































































































































































import AuthService from '@/services/auth-service'
import { Vue, Component, Mixins } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class NavigationDrawer extends Mixins(AuthService) {
  drawer = true

  logout() {
    this.$router.push('/')
    this.$store.state.token = null
    this.$store.state.user = null
    localStorage.removeItem('accessToken')
    this.$store.state.showAppbar = false
  }
}
